<template>
  <section :id="$options.name" class="amenities" ref="amenities">
    <h2 class="amenities__title">Cosa troverai</h2>
    <p class="amenities__subtitle">Alcuni servizi potrebbero essere a pagamento</p>
    <spoken-langs class="amenities__langs" :languages="property.spoken_languages" />
    <div class="amenities__content">
      <ul class="amenities__list">
        <template v-for="(amenity, amenity_index) in amenities">
          <li
            class="amenities__list-item"
            v-if="amenity_index < show"
            :key="_uid + 'amenity' + amenity_index"
          >
            <amenity :item="amenity" :type="'property'" />
          </li>
        </template>
      </ul>
    </div>
    <span v-if="amenities.length > show" class="amenities__show" v-b-modal="'modal_amenities'">
      Mostra tutti e {{ amenities.length }} i servizi
      <vb-icon
        :name="'angle_small_right'"
        :size=18
        :color="sass('info')"
      />
    </span>
    <vb-modal
      :vb_options="{
        id: 'modal_amenities',
        title: property.name + ': Servizi',
        size: is_mobile() ? 'lg' : 'xl',
        centered: true,
        hide_footer: true
      }"
    >
      <ul class="amenities__modal">
        <li
          class="amenities__modal-item"
          v-for="(amenity, amenity_index) in amenities"
          :key="_uid + 'amenity' + amenity_index"
        >
          <amenity :item="amenity" :type="'property'" />
        </li>
      </ul>
    </vb-modal>
  </section>
</template>

<script>
import Amenity from "@liveeps/components/atoms/amenity"
import SpokenLangs from "@liveeps/components/blocks/detail/amenities/spoken-langs"

export default {
  inheritAttrs: false,
  name: 'amenities',

  components: {
    'amenity': Amenity,
    'spoken-langs': SpokenLangs,
  },

  props: {
    property: Object,
  },

  data() {
    return {
      show: 21
    }
  },

  computed: {
    amenities() {
      return Object.values(this.property.amenities || {})
    }
  },

  created() {
  },

  mounted() {
  },

  methods: {
  },
}
</script>

<style lang="scss" scoped>

  .amenities {
    @extend %section;
    @extend %section_margin;

    &__title {
      @extend %section__title;
      margin-bottom: 0;
    }

    &__content {
      @extend %section__content;
    }

    &__subtitle {

      @include media-breakpoint-up(lg){
        margin-bottom: 0;
      }
    }

    &__langs {
      @include media-breakpoint-up(lg){
        margin-top: $grid-gutter-width / 3;
      }
    }

    &__list {
      padding: 0;
      margin: 0;

      @include media-breakpoint-down(lg) {
        display: block;
      }

      @include media-breakpoint-up(lg) {
        display: flex;
        flex-wrap: wrap;
        height: 245px;
        overflow: hidden;
      }

      &-item {
        list-style: none;
        padding: 3px 0;

        @include media-breakpoint-up(lg) {
          line-height: normal;
          padding: 5px 30px 5px 0;
          margin: 3px 5px 3px 0;
          width: 32%;
          display: flex;
          align-items: center;
          color: $gray-700;
        }
      }
    }

    &__modal {
      @extend .amenities__list;
      height: auto;
      overflow: auto;

      &-item {
        @extend .amenities__list-item;
      }
    }

    &__show {
      display: flex;
      color: var(--info);
      text-decoration: underline;
      cursor: pointer;
      align-items: flex-end;

      @include media-breakpoint-up(lg){
        margin-top: $grid-gutter-width / 2;
        margin-left: 20px;
      }
    }
  }

</style>